import React, { useState } from 'react';
import { GridColumn, GridRow } from 'app/member/layouts/grid';
import { Spacer } from 'app/layouts/generic';
import { Button } from 'app/shared/button';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { useAdminService } from 'hooks/api/users/admin';
import styles from './admins.module.css';

const INITIAL_FORM = {
  firstname: '',
  lastname: '',
  email: '',
  password: ''
};

export const AddAdminForm = ({ closeModal = () => {}, onCreated = () => {} }) => {
  const { createAdmin } = useAdminService();

  const [form_data, setFormData] = useState(INITIAL_FORM);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (name, value) => setFormData((prev) => ({ ...prev, [name]: value }));

  const form_is_valid =
    form_data.firstname.trim() !== '' &&
    form_data.email.trim() !== '' &&
    form_data.password.trim() !== '';

  const handleSubmit = async () => {
    if (!form_is_valid) return;
    setSubmitting(true);

    const data = {
      firstname: form_data.firstname.trim(),
      lastname: form_data.lastname.trim(),
      email: form_data.email.trim(),
      password: form_data.password
    };

    const { admin, success } = await createAdmin(data);
    setSubmitting(false);

    if (success) {
      onCreated({ ...data, ...(admin || {}) });
      setFormData(INITIAL_FORM);
      closeModal();
    }
  };

  return (
    <div className={styles.form}>
      <h2 className={styles.title}>Add Admin</h2>

      <Spacer multiple={3} />

      <GridRow num_of_columns={2}>
        <GridColumn>
          <DetailItem title="First name" required>
            <SimpleInput
              wrapperClassName={styles.noMargin}
              value={form_data.firstname}
              onInput={(value) => handleChange('firstname', value)}
              placeholder="Jane"
            />
          </DetailItem>
        </GridColumn>
        <GridColumn>
          <DetailItem title="Last name">
            <SimpleInput
              wrapperClassName={styles.noMargin}
              value={form_data.lastname}
              onInput={(value) => handleChange('lastname', value)}
              placeholder="Doe"
            />
          </DetailItem>
        </GridColumn>
      </GridRow>

      <Spacer multiple={2} />

      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Email" required>
            <SimpleInput
              type="email"
              wrapperClassName={styles.noMargin}
              value={form_data.email}
              onInput={(value) => handleChange('email', value)}
              placeholder="jane@go-mailer.com"
            />
          </DetailItem>
        </GridColumn>
      </GridRow>

      <Spacer multiple={2} />

      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Password" required>
            <SimpleInput
              type="password"
              wrapperClassName={styles.noMargin}
              value={form_data.password}
              onInput={(value) => handleChange('password', value)}
              placeholder="Minimum 8 characters"
            />
          </DetailItem>
        </GridColumn>
      </GridRow>

      <Spacer multiple={3} />

      <div className={styles.actions}>
        <Button text="Cancel" type="secondary" onClick={closeModal} />
        <Button
          text="Add Admin"
          onClick={handleSubmit}
          disabled={!form_is_valid}
          loading={submitting}
        />
      </div>
    </div>
  );
};
